module.exports = __webpack_public_path__ + "img/s8Bg9.737907c9.jpg";